// src/components/ScrollToTop.js

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  // Extraemos el pathname (ej. "/", "/contacto") de la ubicación actual
  const { pathname } = useLocation();

  // Usamos useEffect para ejecutar una acción cada vez que el 'pathname' cambie
  useEffect(() => {
    // Hacemos scroll a la posición 0, 0 (arriba del todo)
    window.scrollTo(0, 0);
  }, [pathname]); // El array de dependencias con 'pathname' asegura que esto solo se ejecute al cambiar la URL

  // Este componente no renderiza ningún elemento visual
  return null;
}

export default ScrollToTop;